import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WorkHistoryIcon(props: IconProps) {
    return <Icon {...props} iconKey={"work_history"}/>
}
